import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Kpi } from 'app/modules/admin/common/kpi-widget/kpi';
import { Observable } from 'rxjs';

@Injectable({providedIn: 'root'})
export class DeviceKpisApi {

    /**
     * Constructor
     */
    constructor(private httpClient: HttpClient)
    {
    }

    /**
     * Gets info about all the existing KPIs from the API.
     *
     * @return Example response:
     * [
     *     {
     *         "title": "Online",
     *         "value": 3,
     *         "total": 19
     *     },
     *     {
     *         "title": "Open issues",
     *         "value": 5,
     *         "total": null
     *     },
     *     {
     *         "title": "With errors",
     *         "value": 6,
     *         "total": 19
     *     },
     *     {
     *         "title": "With warnings",
     *         "value": 6,
     *         "total": 19
     *     }
     * ]
     */
    getAllDeviceKpis(companyId: number): Observable<Kpi[]> {
        return this.httpClient.get<Kpi[]>(`api/kpis/${companyId}`);
    }
}
